import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SolidClock from './icon-clock-solid.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SolidClock {...validProps} />;
}
SvgComponent.iconName = 'solidClock';

/**
 * @deprecated This is a legacy icon
 */
export const SolidClockIcon = svgIconWrapper(SvgComponent);
